export default __webpack_public_path__ + "804745666e5639b750573f6dda983e62.svg";